import { React, Link, TextInput2 as TextInput, DropDown2 as DropDown } from "../../../../common";

const RenderChildOtherCredits = (props) => {
  const { path, item, count, otherCreditTypes, onInputChanged } = props;

  const OnDeleteClicked = (e) => {
    e.preventDefault();
    if (onInputChanged) onInputChanged(`${path}.delete`.replace(/\./g, '_'), true);
  }

  return (
    <>
      {count > 1 && (
        <div className="formPartition">
          <div className="closePartition">
            <Link to="#" onClick={(e) => OnDeleteClicked(e)}>&#x2715; &nbsp;Delete</Link>
          </div>
        </div>
      )}
      <ul className="formContentIIcol">
        <li className="formContentIIcol">
          <div className="form1003ContentHead">Credit Type</div>
          <div className="typeicon"></div>
          <DropDown
            path={`${path}.assetType`}
            value={item?.assetType}
            items={otherCreditTypes}
            displayName={"text"}
            displayValue={"value"}
            onInputChildChanged={onInputChanged}
          />
        </li>
        <li className="formContentIIcol">
          <div className="form1003ContentHead">Cash or Market Value</div>
          <div className="form_dollaricon"></div>
          <TextInput
            path={`${path}.cashOrMarketValue`}
            value={item?.cashOrMarketValue}
            onInputChildChanged={onInputChanged}
          />
        </li>
      </ul>
    </>
  );
};

const Component = (props) => {
  const { items, otherCreditTypes, onAddArrayList, onInputChanged } = props;
  const item = items && items.childs && items.childs.length > 0 ? items.childs[0] : null;

  const OnAddNewAsset = (e) => {
    e.preventDefault();
    let obj = {
      title: item?.title,
      borrowerType: item?.borrowerType,
      delete: false
    };
    if (onAddArrayList) onAddArrayList('otherCredits', obj);
  };

  return (
    <>
      <div className="form1003BlkHead">
        <div className="formHeadContent">Other Credits You Have</div>
        <div className="form1003Blk_right">
          <input
            type="button"
            defaultValue="&#65291; Another"
            className="headRight_button"
            onClick={(e) => OnAddNewAsset(e)}
          />
        </div>
      </div>
      <div className="form1003ContentBlk">
        {items && items.childs && items.childs.map((x) => {
          if (!x.delete) {
            return (
              <RenderChildOtherCredits
                count={items.childs.filter((x) => !x.delete).length}
                key={x.index}
                path={`otherCredits.${x.index}`}
                item={x}
                otherCreditTypes={otherCreditTypes}
                onInputChanged={onInputChanged}
              />
            )
          } else { return null }
        })}
      </div>
    </>
  );
};

export default Component;
